import moment from 'moment';

export function formatTimeFromHoursAndMinutes(hours, minutes) {
  const time = moment();
  time.set({hour:0,minute:0,second:0,millisecond:0});
  time.set({hour: hours, minute: minutes});
  return time.format('HH:mm');
}
